import { Plugin } from 'ckeditor5/src/core';
import OpenscopIconsEditing from './OpenscopIconsEditing';
import OpenscopIconsUI from './OpenscopIconsUI';
export default class OpenscopIcons extends Plugin {
    static get pluginName() {
        return 'OpenscopIcons';
    }
    static get requires() {
        return [OpenscopIconsUI, OpenscopIconsEditing];
    }
    init() {
        const editor = this.editor;
        editor.config.define(OpenscopIcons.pluginName, {
            icons: []
        });
    }
}
